import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../lib/api.js';
import { Itineraire } from '../components/Itineraire.jsx';
import { formaterMontant, resumerPeriode } from '../lib/format.js';

/**
 * Consultation publique d'un voyage partagé. Aucun compte n'est requis, et la
 * réponse du serveur ne contient ni participants, ni description du groupe :
 * un lien circule bien au-delà du cercle auquel on pensait en l'activant.
 */
export function SharedTrip() {
  const { token } = useParams();
  const [voyage, setVoyage] = useState(null);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    let annule = false;

    api
      .get(`/share/${token}`)
      .then((data) => !annule && setVoyage(data.trip))
      .catch((echec) => !annule && setErreur(echec.message));

    return () => {
      annule = true;
    };
  }, [token]);

  if (erreur) {
    return (
      <main className="page page--etroite">
        <section className="verre">
          <h1>Lien indisponible</h1>
          <p>{erreur}</p>
          <p>
            Demandez un nouveau lien à la personne qui vous a partagé ce voyage.
          </p>
          <p>
            <Link to="/">Découvrir HolidAI</Link>
          </p>
        </section>
      </main>
    );
  }

  if (!voyage) {
    return (
      <main className="page page--etroite">
        <p role="status">Chargement…</p>
      </main>
    );
  }

  const budget = formaterMontant(voyage.budget.amount, voyage.budget.currency);

  return (
    <main className="page page--etroite">
      <section className="verre">
        <p className="fil">Itinéraire partagé</p>
        <h1>{voyage.name}</h1>

        <dl className="fiches">
          {voyage.destination.label !== voyage.name && (
            <div className="fiche">
              <dt>Destination</dt>
              <dd>{voyage.destination.label}</dd>
            </div>
          )}
          <div className="fiche">
            <dt>Quand</dt>
            <dd>{resumerPeriode(voyage)}</dd>
          </div>
          {budget && (
            <div className="fiche">
              <dt>Budget</dt>
              <dd>{budget}</dd>
            </div>
          )}
        </dl>

        {voyage.itinerary.mode && (
          <Itineraire itineraire={voyage.itinerary} lectureSeule />
        )}

        <p className="pied-partage">
          Itinéraire préparé avec <Link to="/">HolidAI</Link>.
        </p>
      </section>
    </main>
  );
}
